import angular from 'angular';
import 'angular-bootstrap-calendar';

// Load all services
import '../../../../../lib/service';

// Dependencies
import calendar from '../calendar';
import fullCalendar from '../fullCalendar';

// Component
import component from './calendarWrapper.component';

const moduleName = 'staff.dashboardScreen.calendarWrapper';
let module = angular.module(moduleName, [
  calendar.name,
  fullCalendar.name,
]);

module.component('calendarWrapper', component);

export default module;
